// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Products_stepTitle__6HvEW {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--primary-dark-blue);
  margin-bottom: 15px;
  text-align: center;
}

.Products_tableContainer__mjvhw {
  margin-top: 20px;
}

.Products_estimatedTotal__vS5Um {
  text-align: right;
  margin-top: 20px;
  padding-right: 5px;
  font-weight: 600;
  color: var(--primary-dark-blue);
}

.Products_selectionBlock__aoaL\\+ {
  margin-top: 30px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.Products_selectionBlockQuestion__OZIOE {
  display: block;
  font-weight: 600;
  font-size: 1.1rem;
  color: var(--primary-dark-blue);
  margin-bottom: 5px;
}

.Products_selectionBlockSubtext__xI825 {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 10px;
}

.Products_selectionBlockOptions__fM1X\\+ {
  display: flex;
  gap: 20px;
}

.Products_selectionBlockOption__HAAbe label {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  cursor: pointer;
  padding-bottom: 5px;
}

.Products_selectionBlockOption__HAAbe input {
  margin-right: 8px;
}

.Products_selectionBlockSubgroup__W9Ia2 {
  margin-top: 20px;
  padding-top: 20px;
}

.Products_emrPicklist__dcsM3 {
  box-sizing: border-box;
  width: 100%;
  padding: 12px 15px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: white;
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.Products_emrPicklist__dcsM3:focus {
  outline: none;
  border-color: var(--secondary-bright-blue);
  box-shadow: 0 0 0 3px rgba(16, 162, 221, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/RegistrationForm/steps/Products/Products.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,6CAA6C;AAC/C","sourcesContent":[".stepTitle {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.tableContainer {\n  margin-top: 20px;\n}\n\n.estimatedTotal {\n  text-align: right;\n  margin-top: 20px;\n  padding-right: 5px;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n}\n\n.selectionBlock {\n  margin-top: 30px;\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n}\n\n.selectionBlockQuestion {\n  display: block;\n  font-weight: 600;\n  font-size: 1.1rem;\n  color: var(--primary-dark-blue);\n  margin-bottom: 5px;\n}\n\n.selectionBlockSubtext {\n  font-size: 0.9rem;\n  color: #6c757d;\n  margin-bottom: 10px;\n}\n\n.selectionBlockOptions {\n  display: flex;\n  gap: 20px;\n}\n\n.selectionBlockOption label {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  cursor: pointer;\n  padding-bottom: 5px;\n}\n\n.selectionBlockOption input {\n  margin-right: 8px;\n}\n\n.selectionBlockSubgroup {\n  margin-top: 20px;\n  padding-top: 20px;\n}\n\n.emrPicklist {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px 15px;\n  margin-top: 10px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: white;\n  font-size: 1rem;\n  font-family: 'Poppins', sans-serif;\n  cursor: pointer;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.emrPicklist:focus {\n  outline: none;\n  border-color: var(--secondary-bright-blue);\n  box-shadow: 0 0 0 3px rgba(16, 162, 221, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepTitle": `Products_stepTitle__6HvEW`,
	"tableContainer": `Products_tableContainer__mjvhw`,
	"estimatedTotal": `Products_estimatedTotal__vS5Um`,
	"selectionBlock": `Products_selectionBlock__aoaL+`,
	"selectionBlockQuestion": `Products_selectionBlockQuestion__OZIOE`,
	"selectionBlockSubtext": `Products_selectionBlockSubtext__xI825`,
	"selectionBlockOptions": `Products_selectionBlockOptions__fM1X+`,
	"selectionBlockOption": `Products_selectionBlockOption__HAAbe`,
	"selectionBlockSubgroup": `Products_selectionBlockSubgroup__W9Ia2`,
	"emrPicklist": `Products_emrPicklist__dcsM3`
};
export default ___CSS_LOADER_EXPORT___;
